import { ChangeEvent, Layout } from "@mcleod/components";
import { AutogenLayoutCarrierPortal } from "./autogen/AutogenLayoutCarrierPortal";
import { TableCarrierOfferHistory } from "./TableCarrierOfferHistory";

export class CarrierPortal extends AutogenLayoutCarrierPortal {

  override onLoad() {
    this.showSelectedTabData();
  }
  afterTabSelection(event: ChangeEvent) {
    this.showSelectedTabData();
  }

  private showSelectedTabData() {
    const tabLayout = this.tabset.getActiveTab()?.components?.[0] as Layout;
    if (tabLayout?.mainDataSource) {
      // for all layouts except TableCarrierOfferHistory, pass in empty filter so beforeExecutionListeners can modify the filter
      const filter = (tabLayout instanceof TableCarrierOfferHistory) ? null : {}
      tabLayout.mainDataSource.search(filter);
    }
  }
}
